export const DATE_FORMAT_POINT_SINGLE_VOYAGE = 'DD.MM.YYYY HH:mm'